/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { insertMailingListInput } from './DataActionExtension.g';

/**
 * MailingListSignup Input Action
 */

export class MailingListSignupInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;

    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => { return false; };
    public getCacheKey = () => { return 'IMailingListSignup'; };
    public getCacheObjectType = () => 'IMailingListSignup';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IMailingListSignupData {
    text: string;
}

export type mailingInfo = {
    name: string;
    zipCode: string;
    email: string;
};

export const createMailingListInput = (inputData: mailingInfo, appContext: Msdyn365.ICoreContext<{ [x: string]: unknown }>): MailingListSignupInput => {
    const { mailingListID, mailingListSourceID } = <{ [x: string]: unknown }>appContext.app.config;
    return new MailingListSignupInput(
        insertMailingListInput(
            <string>mailingListID,
            <string>mailingListSourceID,
            inputData.email,
            inputData.name,
            inputData.zipCode
        )
    );
};

export async function mailingListAction(input: MailingListSignupInput, ctx: Msdyn365.IActionContext): Promise<IMailingListSignupData> {
    return input.input.execute(ctx);
}

export const IMailingListSignupAction = Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMailingListSignupData>>mailingListAction,
    input: createMailingListInput
});